import { KeyValue } from '@/main/models/common';
import { ProcurementReportScheduleRequest } from '@/main/models/request';

export enum SchedulerUsersTypes {
  GET_SCHEDULER_USERS = '@schedulerUsers/GET_SCHEDULER_USERS',
  SAVE_SCHEDULER_USERS = '@schedulerUsers/SAVE_SCHEDULER_USERS',
  RESET_REDUCER_SCHEDULER_USERS = '@schedulerUsers/RESET_REDUCER_SCHEDULER_USERS'
}

export interface SchedulerUsersState {
  readonly schedulerUsers: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetSchedulerUsers {
  type: typeof SchedulerUsersTypes.GET_SCHEDULER_USERS;
  payload: ProcurementReportScheduleRequest;
}

export interface SaveSchedulerUsers {
  type: typeof SchedulerUsersTypes.SAVE_SCHEDULER_USERS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerSchedulerUsers {
  type: typeof SchedulerUsersTypes.RESET_REDUCER_SCHEDULER_USERS;
}

export type SchedulerUsersActionTypes =
  | GetSchedulerUsers
  | SaveSchedulerUsers
  | ResetReducerSchedulerUsers;
